import gql from 'graphql-tag';

export const CreditorListQuery = gql`
  query creditorList($where: CreditorWhereInput, $limit: CreditorLimitInput) {
    creditorList(where: $where, limit: $limit) {
      id
      jmeno
      mesto
      adresa
      sidlo
      ico
      telefon
      email
      web
    }
  }
`;
